<!-- <p>host-approval works!</p> -->

<div class="host-approval-container">
  <div class="host-approval-header">
    New Visitor
    <button
      *ngIf="screenSize == ScreenType.Mobile && isApprovePopUp"
      mat-mini-fab
      [mat-dialog-close]="true"
    >
      <mat-icon>clear</mat-icon>
    </button>
  </div>

  <div
    *ngIf="isFetched"
    [ngClass]="{
      'host-approval-details':
        screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,
      'host-approval-details-mobile': screenSize == ScreenType.Mobile
    }"
  >
    <div class="visitor-gate-entry-form">
      <!-- <div *ngIf="isApprovePopUp" style="margin-top: 45px"></div> -->
      <form [formGroup]="visitorGateEntryHostApproval">
        <mat-grid-list
          [cols]="screenSize == ScreenType.Mobile ? 1 : 3"
          rowHeight="75px"
          gutterSize="25px"
        >
          <mat-grid-tile [rowspan]="screenSize == ScreenType.Mobile ? 3 : 4">
            <img
              [src]="visitorGateEntryHostApproval.controls.profilePicture.value"
              alt=""
          /></mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field
              hideRequiredMarker
              subscriptSizing="dynamic"
              appearance="outline"
            >
              <mat-label>Full Name</mat-label>
              <input
                readonly
                matInput
                formControlName="fullName"
              /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field
              hideRequiredMarker
              subscriptSizing="dynamic"
              appearance="outline"
            >
              <mat-label>Email</mat-label>
              <input
                readonly
                matInput
                formControlName="email"
              /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field
              hideRequiredMarker
              subscriptSizing="dynamic"
              appearance="outline"
            >
              <mat-label>Contact Number</mat-label>
              <input
                readonly
                matInput
                formControlName="phoneNumber"
              /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile>
            <mat-form-field
              hideRequiredMarker
              subscriptSizing="dynamic"
              appearance="outline"
            >
              <mat-label>Address</mat-label>

              <textarea
                readonly
                formControlName="visitorAddress"
                cdkTextareaAutosize
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="1"
                matInput
              ></textarea>
            </mat-form-field>
          </mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field
              hideRequiredMarker
              subscriptSizing="dynamic"
              appearance="outline"
            >
              <mat-label>Purpose</mat-label>
              <input
                readonly
                matInput
                formControlName="purpose"
              /> </mat-form-field
          ></mat-grid-tile>

          <mat-grid-tile
            ><mat-form-field
              hideRequiredMarker
              subscriptSizing="dynamic"
              appearance="outline"
            >
              <mat-label>Car Registration</mat-label>
              <input
                readonly
                matInput
                formControlName="carRegistration"
              /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            ><div class="notify-host-button">
              <button
                [disabled]="isDisable || isFetchingRequest"
                (click)="onClickButton(1)"
                [ngStyle]="
                  isDisable ? { background: 'gray' } : { background: 'green' }
                "
                mat-raised-button
              >
                Approve
              </button>
            </div>
          </mat-grid-tile>
          <mat-grid-tile
            ><div class="notify-host-button">
              <button
                [disabled]="isDisable || isFetchingRequest"
                (click)="onClickButton(-1)"
                [ngStyle]="
                  isDisable ? { background: 'gray' } : { background: 'red' }
                "
                mat-raised-button
              >
                Reject
              </button>
            </div>
          </mat-grid-tile>
        </mat-grid-list>
      </form>
    </div>
  </div>
  <div *ngIf="!isFetched">
    <div class="visitor-msg">
      <h4>Fetching Details!</h4>
      <br />
      <mat-spinner></mat-spinner>
    </div>
  </div>
</div>
<ng-template #VisitorApprovalDialog>
  <h2 matDialogTitle>Visitor Approval</h2>
  <mat-dialog-content>
    <div class="visitor-msg">
      <b
        ><i> {{ "Response updated! You can close this window" }}</i></b
      >
    </div>
  </mat-dialog-content>
</ng-template>
<ng-template #InProgresslDialog>
  <h2 matDialogTitle>Applying Changes!</h2>
  <mat-dialog-content>
    <div class="visitor-msg">
      <mat-spinner></mat-spinner>
    </div>
  </mat-dialog-content>
</ng-template>
<ng-template #FailedErrorDialog>
  <h2 matDialogTitle>Response Failed</h2>
  <mat-dialog-content>
    <b
      ><i> {{ "Error occured, Please retry!" }}</i></b
    >
    <br />
    <div class="visitor-msg">
      <button mat-raised-button (click)="refreshWindow()">Re-try</button>
    </div>
  </mat-dialog-content>
</ng-template>
